<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDeny_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M19.155 21.512a1.667 1.667 0 1 0 2.357-2.357L14.357 12l7.155-7.155a1.667 1.667 0 1 0-2.357-2.357L12 9.643 4.845 2.488a1.667 1.667 0 1 0-2.357 2.357L9.643 12l-7.155 7.155a1.667 1.667 0 1 0 2.357 2.357L12 14.357z"
        clip-rule="evenodd"
    />
</svg>
